import React from "react";
import ScrollToTop from "../component/ScrollToTop";
import SignIn from "../component/Signin";

const SigninPage = () => {
  return (
    <>
      <ScrollToTop />
      <SignIn />
    </>
  );
};

export default SigninPage;
